angular.module 'zc.projects'

.service 'projectStatues', ($filter) ->
  terminated_after_trial:
    status: 'terminated_after_trial'
    text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.terminatedAfterTrial')
    statusClass: 'label label-danger'
    showsDate: false
  terminated_after_contract:
    status: 'terminated_after_contract'
    text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.terminatedAfterContract')
    statusClass: 'label label-danger'
    showsDate: false
  contracted:
    status: 'contracted'
    text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.contracted')
    statusClass: 'label label-success'
    showsDate: true
  trial:
    status: 'trial'
    text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.trial')
    statusClass: 'label label-warning'
    showsDate: true
  before_trial:
    status: 'before_trial'
    text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.beforeTrial')
    statusClass: 'label label-warning'
    showsDate: true
  idle:
    status: 'idle'
    text: $filter('translate')('projects.directives.projects.zcLabelProjectStatus.idle')
    statusClass: 'label label-info'
    showsDate: false

.directive 'zcLabelProjectStatus', (projectStatues) ->
  restrict: 'E'
  scope:
    project: '='
    range: '='
  template: """
    <span ng-class="label.statusClass">
      {{label.text}}
      <span ng-if="label.showsDate">
        <span ng-if="label.status == 'contracted' && project.contracted_at">
          ({{project.contracted_at | date : 'yyyy/M/d' }})
        </span>
        <span ng-if="label.status == 'trial' && project.trial_started_at">
          ({{project.trial_started_at | date : 'yyyy/M/d' }})
        </span>
      </span>
    </span>
    <br>
  """

  link: (scope, element, attrs) ->
    $(element).addClass("project-status")
    updateLabels = (range) ->
      scope.label = projectStatues[scope.project.contract_status]
    scope.$watch 'range', updateLabels



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/directives/projects/zc_label_project_status.js.coffee